if (!customElements.get("compare-table")) {
  class CompareTable extends HTMLElement {
    static OPEN_CLASS = "is-open";
    static SCROLLABLE_CLASS = "is-scrollable";

    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
      this.handleUpdateRef = this.handleUpdate.bind(this);
      this.handleResizeRef = this.handleResize.bind(this);
    }

    handleUpdate(event) {
      if (!event.detail.html) return;

      this.innerHTML = event.detail.html;
      this.handleToggle();
    }

    handleResize() {
      this.tableHead = this.querySelector("[js-table-head]");
      if (!this.tableHead) return this.handleScrollableElement();

      this.style.setProperty(
        "--table-head-height",
        this.tableHead.clientHeight + "px"
      );
    }

    handleScrollableElement() {
      this.scrollableElement = this.querySelector("[js-scrollable-element]");
      if (!this.scrollableElement) return;

      this.scrollableElement.classList.toggle(
        CompareTable.SCROLLABLE_CLASS,
        this.scrollableElement.scrollHeight >
          this.scrollableElement.clientHeight
      );
    }

    handleToggle() {
      this.classList.toggle(CompareTable.OPEN_CLASS);
      document.documentElement.classList.toggle("lock");

      this.handleScrollableElement();
    }

    handleClose() {
      this.classList.remove(CompareTable.OPEN_CLASS);
      document.documentElement.classList.remove("lock");
    }

    handleRemoveElement(handle) {
      this.querySelectorAll(`[data-handle="${handle}"]`).forEach((element) =>
        element.remove()
      );

      this.updateCompareTitleCount();

      document.dispatchEvent(
        new CustomEvent("compare-bar:remove", { detail: { handle } })
      );
    }

    updateCompareTitleCount() {
      const title = this.querySelector("[js-title]");
      if (!title) return;

      const newCount = Number(title.getAttribute("data-current-count")) - 1;

      title.innerText = title
        .getAttribute("data-template")
        .replace("{{ count }}", newCount);

      title.setAttribute("data-current-count", newCount);

      const innerElement = this.querySelector("[js-compare-inner]");
      if(!innerElement) return;
      innerElement.style.setProperty("--columns", newCount + 1);
    }

    handleClick(event) {
      const closeTarget = event.target.closest("[js-close-table]");
      if (closeTarget) {
        event.preventDefault();
        return this.handleClose();
      }

      const removeTarget = event.target.closest("[js-table-remove]");
      if (removeTarget) {
        event.preventDefault();
        return this.handleRemoveElement(
          removeTarget.getAttribute("js-table-remove")
        );
      }
    }

    disconnectedCallback() {
      document.removeEventListener(
        "compare-table:toggle",
        this.handleToggleRef
      );
      document.removeEventListener(
        "compare-table:update",
        this.handleUpdateRef
      );

      window.removeEventListener("resize", this.handleResizeRef);
    }

    connectedCallback() {
      document.addEventListener("compare-table:toggle", this.handleToggleRef);
      document.addEventListener("compare-table:update", this.handleUpdateRef);

      this.addEventListener("click", this.handleClick.bind(this));

      window.addEventListener("resize", this.handleResizeRef);
      this.handleResize();
    }
  }

  customElements.define("compare-table", CompareTable);
}
